// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__1YEaU","container":"style_container__23pX-","footerNav":"style_footerNav__3Mvrz"};